import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatDistanceToNow } from 'date-fns';

const ChatMessage = ({ message, currentUser, isStreaming = false }) => {
  const isAssistant = message?.type === 'assistant';
  const timestamp = new Date(message?.timestamp);

  return (
    <div className={`flex ${isAssistant ? 'justify-start' : 'justify-end'} mb-4`}>
      <div className={`flex max-w-[80%] ${isAssistant ? 'flex-row' : 'flex-row-reverse'} items-start space-x-3`}>
        {/* Avatar */}
        <div className={`flex-shrink-0 ${isAssistant ? 'mr-3' : 'ml-3'}`}>
          {isAssistant ? (
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="Bot" size={16} className="text-primary" />
            </div>
          ) : (
            <img
              src={currentUser?.avatar}
              alt={currentUser?.avatarAlt || 'User avatar'}
              className="w-8 h-8 rounded-full object-cover"
            />
          )}
        </div>

        {/* Message Content */}
        <div className={`flex flex-col ${isAssistant ? 'items-start' : 'items-end'}`}>
          <div
            className={`px-4 py-3 rounded-lg ${
              isAssistant
                ? 'bg-muted text-foreground'
                : 'bg-primary text-primary-foreground'
            } ${isStreaming ? 'animate-pulse' : ''}`}
          >
            {/* Image if present */}
            {message?.image && (
              <div className="mb-3">
                <img
                  src={message?.image}
                  alt={message?.imageAlt || 'Uploaded image'}
                  className="max-w-64 max-h-48 rounded-lg object-cover"
                />
              </div>
            )}

            {/* Text content */}
            <div className="whitespace-pre-wrap text-sm leading-relaxed">
              {message?.content}
              {isStreaming && (
                <span className="ml-1 animate-pulse">▊</span>
              )}
            </div>

            {/* Error indicator */}
            {message?.isError && (
              <div className="flex items-center mt-2 text-destructive">
                <Icon name="AlertTriangle" size={12} className="mr-1" />
                <span className="text-xs">Failed to send</span>
              </div>
            )}

            {/* Suggestions/Actions for assistant messages */}
            {isAssistant && message?.suggestions && (
              <div className="mt-3 flex flex-wrap gap-2">
                <button className="text-xs px-2 py-1 bg-primary/10 hover:bg-primary/20 rounded text-primary transition-colors">
                  Save Recipe
                </button>
                <button className="text-xs px-2 py-1 bg-primary/10 hover:bg-primary/20 rounded text-primary transition-colors">
                  Add to Menu
                </button>
                <button className="text-xs px-2 py-1 bg-primary/10 hover:bg-primary/20 rounded text-primary transition-colors">
                  Generate Shopping List
                </button>
              </div>
            )}
          </div>

          {/* Timestamp */}
          <div className="text-xs text-muted-foreground mt-1">
            {formatDistanceToNow(timestamp, { addSuffix: true })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;